import { IMerchantCoupons } from "@/i/coupons.state";
import Api from "@/api/index.ts";
import { factoryMerchantCoupons } from "@/services/factory/coupons";
import { ICoupon } from "@/i/coupon";

const initMerchantCoupons: IMerchantCoupons = {
  merchant: null,
  countCoupons: 0,
  isLoading: false,
  coupons: null
};

export default {
  namespaced: true,
  state: initMerchantCoupons,
  actions: {
    async setMerchantCoupons({ commit }, { id, page }) {
      commit("isLoading");
      const { data } = await Api.getCouponsOfMerchant(id, 10, page);
      const merchant: IMerchantCoupons = factoryMerchantCoupons(data);
      page > 0
        ? commit("updateMerchant", merchant.coupons)
        : commit("setMerchant", merchant);
      commit("isLoading", false);
      return Promise.resolve(merchant);
    },
    clearMerchantCoupons({ commit }) {
      commit("clearMerchantCoupons");
    }
  },
  mutations: {
    setMerchant(state: IMerchantCoupons, merchant: IMerchantCoupons) {
      state = Object.assign(state, merchant);
    },
    updateMerchant(state: IMerchantCoupons, coupons: ICoupon[]) {
      coupons.forEach(i => state.coupons.push(i));
    },
    clearMerchantCoupons(state: IMerchantCoupons) {
      state.coupons = null;
      state.merchant = null;
      state.countCoupons = 0;
    },
    isLoading(state: IMerchantCoupons, isLoading: boolean = true) {
      state.isLoading = isLoading;
    }
  },
  getters: {
    getMerchant: (state: IMerchantCoupons) => state
  }
};
